<template>
    <div class="container">
        <md-dialog :md-active.sync="showDialogCrearNiif" :md-click-outside-to-close="false">
            <md-dialog-title class="dialog-header">
                <span class="header-title">{{ labels.title }}</span>
            </md-dialog-title>
            <md-dialog-content class="dialog-content">
                <div class="form-container">
                    <!-- Información principal -->
                    <div class="form-group">
                        <div class="form-field">
                            <label class="field-label">{{ labels.niif }}</label>
                            <md-field class="custom-field">
                                <md-input type="number" v-model="niif" :placeholder="labels.niif" />
                            </md-field>
                        </div>
                        <div class="form-field">
                            <label class="field-label">{{ labels.description }}</label>
                            <md-field class="custom-field">
                                <md-input type="text" v-model="descripcion" :placeholder="labels.description" />
                            </md-field>
                        </div>
                    </div>

                    <!-- Niveles -->
                    <div class="form-group">
                        <div class="form-field">
                            <label class="field-label">{{ labels.levelFirst }}</label>
                            <md-field class="custom-field">
                                <select v-model="firstLevSel" class="modern-select">
                                    <option value="">{{ labels.select }}</option>
                                    <option v-for="firstLev in listFirstLevel" :key="firstLev.id" :value="firstLev.primer_nivel">
                                        {{ firstLev.descripcion }}
                                    </option>
                                </select>
                            </md-field>
                        </div>
                        <div class="form-field">
                            <label class="field-label">{{ labels.levelSecond }}</label>
                            <md-field class="custom-field">
                                <select v-model="secondLevSel" class="modern-select">
                                    <option value="">{{ labels.select }}</option>
                                    <option v-for="secondLev in listSecondLevel" :key="secondLev.id" :value="secondLev.segundo_nivel">
                                        {{ secondLev.descripcion }}
                                    </option>
                                </select>
                            </md-field>
                        </div>
                    </div>
                </div>
            </md-dialog-content>
            <md-dialog-actions class="dialog-actions">
                <md-button class="md-raised cancel-btn" @click="closeDialog">
                    {{ labels.close }}
                </md-button>
                <md-button class="md-raised md-primary save-btn" @click="confirmSave">
                    {{ labels.save }}
                </md-button>
            </md-dialog-actions>
        </md-dialog>
    </div>
</template>

<script>
import PlanConsolidacion from '../../services/PlanConsolidacion'
import SegundoNivel from '../../services/SegundoNivel';

export default {
    name:"Crear",
    props:['showDialogCrearNiif','vigencia','codReporte','listFirstLevel'],

    data: () => ({
        niif:"",
        descripcion:"",
        firstLevSel:"",
        secondLevSel:"",
        listSecondLevel: [],
        hasUnsavedChanges: false
    }),

    computed:{
        labels(){
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "Crear NIIF",
                    niif : "NIIF",
                    description : "Descripción",
                    select : "Seleccione...",
                    levelFirst : "Primer Nivel",
                    levelSecond : "Segundo Nivel",
                    save : "Guardar",
                    close : "Cerrar",
                }
            }else{
                return {
                    title: "Create NIIF",
                    niif : "NIIF",
                    description : "Description",
                    select : "Select...",
                    levelFirst : "First Level",
                    levelSecond : "Second Level",
                    save : "Save",
                    close : "Close",
                }
            }
        }
    },

    watch: {
        niif() { this.hasUnsavedChanges = true; },
        descripcion() { this.hasUnsavedChanges = true; },
        firstLevSel() { 
            this.hasUnsavedChanges = true;
            this.loadSecondLevel();
        },
        secondLevSel() { this.hasUnsavedChanges = true; }
    },

    methods:{
        clearCampos(){
            this.niif = ""
            this.descripcion = ""
            this.firstLevSel = ""
            this.secondLevSel = ""
            this.hasUnsavedChanges = false
        },

        closeDialog() {
            if (this.hasUnsavedChanges) {
                const message = this.$store.state._language == "es-ES"
                    ? "Tienes cambios sin guardar. ¿Quieres cerrar sin guardar?"
                    : "You have unsaved changes. Do you want to close without saving?";

                if (window.confirm(message)) {
                    this.clicked();
                }
            } else {
                this.clicked();
            }
        },

        confirmSave() {
            const message = this.$store.state._language == "es-ES"
                ? "¿Está seguro que desea crear este NIIF?"
                : "Are you sure you want to create this NIIF?";

            if (window.confirm(message)) {
                this.creaNiif();
            }
        },

        clicked(){
            this.$emit('clicked',false)
            this.clearCampos()
        },

        reload(){
            this.$emit('reload')
        },

        loadSecondLevel(){
            if (this.firstLevSel) {
                SegundoNivel.getAllLevelSecondByLevelFirstByReport(this.firstLevSel, this.codReporte)
                .then((res) => {
                    this.listSecondLevel = res.data.secondLevByFirstLev
                })
                .catch((err) => {
                    console.log(err)
                })
            } else {
                this.listSecondLevel = [];
            }
        },

        creaNiif(){
            if(this.niif == ""){
                this.$toast.error("El campo NIIF debe estar diligenciado")
            }else if(this.descripcion == ""){
                this.$toast.error("El campo Descripción debe estar diligenciado")
            }else if(this.firstLevSel === ""){
                this.$toast.error("El campo primer nivel debe estar diligenciado")
            }else if(this.secondLevSel === ""){
                this.$toast.error("El campo segundo nivel debe estar diligenciado")
            }else{
                let form = {
                    'niif'          : this.niif,
                    'descripcion'   : this.descripcion,
                    'primerNivel'   : this.firstLevSel,
                    'segundoNivel'  : this.secondLevSel,
                    'vigencia'      : this.vigencia,
                    'codReporte'    : this.codReporte,
                    'idUser'        : this.$store.state.userId
                }

                PlanConsolidacion.createPlanconsolidacion(form)
                .then((res) => {
                    this.$toast.success(res.data.message)
                    this.clicked()
                })
                .catch((err) => {
                    if(err.response.status == 412){
                        this.$toast.error(err.response.data.message)
                    }
                })
                .finally(() => {
                    this.reload()
                })
            }
        }
    }
}
</script>

<style scoped>
/* Header del diálogo */
.dialog-header {
    background: #34495e;
    color: white;
    padding: 20px 24px;
    margin: 0;
    border-bottom: 1px solid #2c3e50;
}

.header-title {
    font-size: 1.3rem;
    font-weight: 500;
}

.dialog-content {
    padding: 20px 24px;
}

.form-container {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

/* Grupos de formulario */
.form-group {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
}

.form-field-full {
    width: 100%;
}

/* Labels y campos */
.field-label {
    display: block;
    font-weight: 600;
    color: #2c3e50;
    margin-bottom: 8px;
    font-size: 14px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.field-value {
    padding: 12px 0;
    font-weight: 600;
    color: #34495e;
    font-size: 15px;
    border-bottom: 1px solid #ecf0f1;
}

/* Campos de formulario */
.custom-field {
    margin: 0;
}

.modern-select {
    width: 100%;
    padding: 12px 16px;
    border: 1px solid #bdc3c7;
    border-radius: 4px;
    background: white;
    font-size: 14px;
    color: #2c3e50;
    outline: none;
    transition: border-color 0.2s ease;
}

.modern-select:focus {
    border-color: #3498db;
    box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.1);
}

/* Acciones del diálogo */
.dialog-actions {
    padding: 20px 24px;
    border-top: 1px solid #ecf0f1;
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    background: #f8f9fa;
}

.cancel-btn {
    background: #95a5a6 !important;
    color: white !important;
    font-size: 14px;
    padding: 10px 24px;
    min-width: 100px;
}

.save-btn {
    background: #3498db !important;
    color: white !important;
    font-size: 14px;
    padding: 10px 24px;
    min-width: 100px;
}

.cancel-btn:hover {
    background: #7f8c8d !important;
}

.save-btn:hover {
    background: #2980b9 !important;
}

/* Responsive */
@media (max-width: 768px) {
    .form-group {
        grid-template-columns: 1fr;
        gap: 16px;
    }
    
    .form-container {
        padding: 16px;
    }
    
    .dialog-actions {
        padding: 16px;
    }
}
</style>